import '../../components/reports/mt-shipments.js'
import '../../components/reports/mt-yardsheet.js'
import '../../components/reports/mt-deads.js'
import '../../components/reports/mt-inventory-valuation.js'
import '../../components/reports/mt-receives.js'
import '../../components/reports/mt-closeout-summary.js'

// Essentially the Controller
export function handleReportResults({ report, results }) {
    switch (report) {
        case 'fetchShipmentData':
            displayShipmentsReport({ results })
            break
        case 'fetchYardSheetData':
            displayYardsheetReport({ results })
            break
        case 'fetchDeathData':
            displayDeadsReport({ results })
            break
        case 'fetchReceiveData':
            displayReceivesReport({ results })
            break
        case 'fetchInventoryValuationData':
            displayInventoryValuationReport({ results })
            break
        case 'fetchCloseOutData':
            displayCloseoutSummaryReport({ results })
            break
        default:
            console.error(`No report available`)
    }
}

function displayYardsheetReport({ results }) {
    const resultsContainer = document.getElementById('js-results-container')
    const report = document.createElement('mt-report-yardsheet', {
        is: 'mt-report-yardsheet',
    })

    resultsContainer.appendChild(report)
    report.data = results

    initializePrintElement(report)
}

function displayShipmentsReport({ results }) {
    console.info({ results })
    const resultsContainer = document.getElementById('js-results-container')
    const report = document.createElement('mt-shipments-report', {
        is: 'mt-shipments-report',
    })

    resultsContainer.appendChild(report)
    report.data = results

    initializePrintElement(report)
}

function displayDeadsReport({ results }) {

    const resultsContainer = document.getElementById('js-results-container')
    const report = document.createElement('mt-deads-report', {
        is: 'mt-deads-report',
    })

    resultsContainer.appendChild(report)
    report.data = results

    initializePrintElement(report)

}

function displayReceivesReport({ results }) {

    const resultsContainer = document.getElementById('js-results-container')
    const report = document.createElement('mt-receives-report', {
        is: 'mt-receives-report',
    })

    resultsContainer.appendChild(report)
    report.data = results

    initializePrintElement(report)

}

function displayInventoryValuationReport({ results }) {

    const resultsContainer = document.getElementById('js-results-container')
    const report = document.createElement('mt-iv-report', {
        is: 'mt-iv-report',
    })

    resultsContainer.appendChild(report)
    report.data = results

    initializePrintElement(report)

}

function displayCloseoutSummaryReport({ results }) {

    const resultsContainer = document.getElementById('js-results-container')
    const report = document.createElement('mt-cs-report', {
        is: 'mt-cs-report',
    })

    resultsContainer.appendChild(report)
    report.data = results

    initializePrintElement(report)

}

function initializePrintElement(el) {
    el.addEventListener('printReportEvent', printReport)
}

function printReport() {
    window.print()
}
